import * as types from "../Actions/actionTypes";
import { SharedActions } from "../../../Shared/Redux/Actions/sharedActions";

function actionTypeEndsInSuccess(type: string) {
    return type.substring(type.length - 8) === "_SUCCESS";
}

export const apiCallsInitialState = 0 as number;

export default function apiCallStatusReducer(
    state = apiCallsInitialState,
    action: SharedActions
) {
    if (action.type === types.BEGIN_API_CALL) {
        return state + 1;
    } else if (
        action.type === types.API_CALL_ERROR ||
        actionTypeEndsInSuccess(action.type)
    ) {
        //this value was becoming negative at times, which could mess with template logic.  Now lower-bound at 0
        if (state > 0) {
            return state - 1;
        }
        else {
            return 0;
        }
    }

    return state;
}
